import { render, staticRenderFns } from "./webBar.vue?vue&type=template&id=b422ccf6&scoped=true&"
import script from "./webBar.vue?vue&type=script&lang=js&"
export * from "./webBar.vue?vue&type=script&lang=js&"
import style0 from "./webBar.vue?vue&type=style&index=0&id=b422ccf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b422ccf6",
  null
  
)

export default component.exports